export enum EnumVencimentoArmazenamento {
  TRES_DIAS = "VENCIMENTO_3_DIAS",
  NUNCA = "VENCIMENTO_NUNCA"
}
